import styled from 'styled-components';

export const Container = styled.section`
  margin-bottom: 12rem;
`;

export default Container;
